import script from "./StaffTableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaffTableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./StaffTableComponent.vue?vue&type=style&index=0&id=687f23ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687f23ac"]])

export default __exports__